import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import translate from 'i18n/translate';

export function ProjectsTable({ rows, rsd }) {
  return (
    <Paper>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>{translate('projectName')}</TableCell>
            <TableCell>
              {translate('projectValue')} {rsd ? '(RSD)' : '(EUR)'}
            </TableCell>
            <TableCell>{translate('donor')}</TableCell>
            <TableCell>{translate('projectGoal')}</TableCell>
            <TableCell>{translate('projectDuration')}</TableCell>
            <TableCell>{translate('status')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map(row => (
            <TableRow key={row.id}>
              <TableCell>{row.name}</TableCell>
              <TableCell>
                {row.value && `${new Intl.NumberFormat().format(row.value)}.00`}
              </TableCell>
              <TableCell>{row.donated}</TableCell>
              <TableCell>
                {row.goals.map(goal => {
                  return (
                    <div>
                      <p>- {goal}</p>
                      <br />
                    </div>
                  );
                })}
              </TableCell>
              <TableCell>
                {translate('from')} {row.timeFrom}
                <br />
                {translate('to')} {row.timeTo}
              </TableCell>
              <TableCell>
                {row.finished ? (
                  <div className="status-box-finished text-center">
                    {' '}
                    <span className="red-circle"></span>
                    {translate('finished')}
                  </div>
                ) : (
                  <div className="status-box-active text-center">
                    {' '}
                    <span className="green-circle"></span>
                    {translate('inProgress')}
                  </div>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
}
